
import { DISTRIBUTION_URL, JSONAPI_URL, LABEL_URL, MODIFICATION_URL } from "../../../services/common-urls";
import { createHttpGetOptions, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";

export const ProductsService = {
  fetchProductList: () => MHTTPCL.get(LABEL_URL, {
    section: 'products',
    output: 'json',
  }),
  fetchProductListPage: ({
    startrow
  }) => MHTTPCL.get(LABEL_URL, {
    section: 'products',
    action: 'retrieve_product_page',
    startrow,
    output: 'json',
  }),
  fetchProductListFilter: ({
    label_id,
    artist,
    title,
    release_type,
    release_status,
    format_id,
    format_group,
    channel,
    genre_id,
    release_date_from,
    release_date_to,
    category_1,
    category_2,
    barcode_catalog_error,
    price_list_id,
    price_code_id,
    price_from,
    price_to,
    payback_from,
    payback_to,
    account_id,
    stock_location_id,
    stock_from,
    stock_to,
    no_filter_selected,

    searchType,
    start,
    row_count,
  }) => {
    return MHTTPCL.post(LABEL_URL, {
      label_id,
      artist,
      title,
      release_type,
      release_status,
      format_id,
      format_group,
      channel,
      genre_id,
      release_date_from,
      release_date_to,
      category_1,
      category_2,
      barcode_catalog_error,
      price_list_id,
      price_code_id,
      price_from,
      price_to,
      payback_from,
      payback_to,
      account_id,
      stock_location_id,
      stock_from,
      stock_to,
      no_filter_selected,

      start: start,
      row_count,
      section: 'products',
      action: searchType,
      output: 'json',
    });
  },
  searchProductList: ({
    str,
    barcode_catalog_error,
    start = 0,
    last_filter_used=false,
    digital_physical="",
    row_count,
  }) => {
    return MHTTPCL.post(LABEL_URL, {
      start,
      row_count,
      str,
      barcode_catalog_error,
      digital_physical,
      last_filter_used,
      section: 'products',
      action: 'search_products',
      output: 'json',
    })
  },
  fetchProductDetails: (product_id) => {
    return MHTTPCL.get(LABEL_URL, {
      section: 'products',
      action: 'product_details',
      product_id,
      output: 'json',
    });
  },
  fetchProductOverviewTab: (product_id) => {
    return MHTTPCL.post(LABEL_URL, {
      section: 'products',
      action: 'product_details_tab_overview',
      product_id,
      output: 'json',
    });
  },
  fetchProductRelease: (product_id) => {
    return MHTTPCL.get(JSONAPI_URL, {
      action: 'get_product_release',
      product_id,
    });
  },
  fetchProductTracks: (product_id) => {
    return MHTTPCL.get(LABEL_URL, {
      section: 'products',
      action: 'product_details_tab_tracks',
      product_id,
      output: 'json',
    });
  },
  fetchProductDetailsTabText: (product_id) => {
    return MHTTPCL.get(LABEL_URL, {
      section: 'products',
      action: 'product_details_tab_text',
      product_id,
      output: 'json',
    });
  },
  fetchAdvancedSearchData: () => MHTTPCL.get(LABEL_URL, {
    section: 'products',
    action: 'advance_search_modal',
    output: JSON_STRING,
  }),
  fetchProductSales: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: 'products',
    action: 'product_details_tab_sales',
    product_id,
  }).then(res => {
    return {
      ...res,
      data: {
        salesData: res.data,
      }
    };
  }),

  exportProduct: ({
    label_id = '',
    start_date = '',
    end_date = '',
    format_id = '',
    channel = '',
    price_list_id = '',
    category_1 = '',
    category_2 = '',
    stock_location_id = '',
    section = 'reports',
    action = 'filter_catalog_report',
  }) => MHTTPCL.get(DISTRIBUTION_URL, {
    label_id,
    start_date,
    end_date,
    format_id,
    channel,
    price_list_id,
    category_1,
    category_2,
    stock_location_id,
    section,
    action,
  }, createHttpGetOptions({
    responseType: 'blob'
  })),
  downloadAdvancedSearchXLSFile: (payload) => MHTTPCL.get(LABEL_URL, {
    ...payload,
    section: 'products',
    action: 'product_advance_search_export',
  }, createHttpGetOptions({
    responseType: 'blob'
  })),
  createNewGroupAdvancedSearch: (payload) => MHTTPCL.post(LABEL_URL, {
    ...payload,
    product_group_name1: payload.product_group_name1,
    section: 'products',
    action: 'new_product_group_search_products',
  }),

  removeProductGroup: (relation_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_product_group",
    relation_id: relation_id
  }),

  productGroupModal: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "product_group_modal",
    product_id: product_id,
    output: JSON_STRING
  }),
  //"add_new_group"
  addGroups: (action, product_id, groups) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: action,
    product_id: product_id,
    groups: groups,
    output: JSON_STRING
  }),

  deleteProductAccount: (product_account_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "delete_product_account",
    product_account_id: product_account_id
  }),
  getBarcodeCatalogError: (product_id,error_type) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "barcode_catalog_error",
    product_id: product_id,
    error_type: error_type
  }),
  productDetails: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "product_details",
    product_id: product_id
  }),

  productAddAccountForm: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "product_add_account_form",
    product_id: product_id


  }),

  productAddAccount: (product_id, account_ids) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_add_account",
    product_id: product_id,
    account_ids: account_ids
  }),

  deleteProductTrack: (product_track_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "delete_product_track",
    product_track_id: product_track_id
  }),

  removeProductMedia: (product_media_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_product_media",
    product_media_id: product_media_id

  }),

  addProductPrices: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_product_prices",
    product_id: product_id

  }),

  resetPrices: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "reset_prices",
    product_id: product_id
  }),

  deleteProductPrice: (product_price_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "delete_product_price",
    product_price_id: product_price_id
  }),

  addProductMedia: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "add_product_media",
    product_id: product_id

  }),

  newProductMedia: (product_id, set_no, mechanical_reg_no, media_id) => MHTTPCL.post(LABEL_URL, {
    set_no: set_no,
    media_id: media_id,
    mechanical_reg_no: mechanical_reg_no,
    product_id: product_id,
    action: "new_product_media",
    section: "products",
    output: JSON_STRING
  }),

  editProductMedia: ({ product_media_id }) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "edit_product_media",
    // product_id:product_id,
    product_media_id: product_media_id,
    output: JSON_STRING

  }),


  productDetailsTabStock: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_details_tab_stock",
    product_id: product_id,
    output: JSON_STRING
  }),

  getPproductRelease: (product_id) => MHTTPCL.post(JSONAPI_URL, {
    action: "get_product_release",
    product_id: product_id
  }),

  specialsData: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "specials_data",
    product_id: product_id,
    output: JSON_STRING
  }),

  getSuppliers: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "get_suppliers",
    product_id: product_id,
    output: JSON_STRING

  }),

  addManufacturingOrder: (external_id, supplier_id, supply_order_type, supplier_order_date) => MHTTPCL.post(LABEL_URL, {
    action: "add_manufacturing_order",
    external_id: external_id,
    external_table: "product",
    supplier_id: supplier_id,
    supply_order_type: supply_order_type,
    supplier_order_date: supplier_order_date,
    section: "products",
    output: JSON_STRING
  }),

  productAccountBackorderForm: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "product_account_backorder_form",
    product_id: product_id
  }),

  addProductAccountBackorder: (product_id, account_id, qty) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_product_account_backorder",
    product_id: product_id,
    account_id: account_id,
    qty: qty,
    output: JSON_STRING
  }),

  deleteBackorder: (product_id, backorder_id) => MHTTPCL.post(LABEL_URL, {
    action: "delete_backorder",
    product_id: product_id,
    backorder_id: backorder_id,
    section: "products"
  }),

  productAccountRelationForm: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "product_account_relation_form",
    product_id: product_id

  }),

  removeManualMatch: (relation_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_manual_match",
    relation_id: relation_id
  }),

  addProductAccountRelation: (product_id, account_id, text02) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_product_account_relation",
    product_id: product_id,
    account_id: account_id,
    text02: text02
  }),

  removeCountryRelation: (country_relation_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_country_relation",
    country_relation_id: country_relation_id
  }),

  invertCountries: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "invert_countries",
    product_id: product_id
  }),

  removeCountries: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_countries",
    product_id: product_id
  }),

  excessMechanicalRateModal: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "excess_mechanical_rate_modal",
    product_id: product_id
  }),

  getCountryFormData: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "get_country_form_data",
    product_id: product_id
  }),

  getContracts: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "get_contracts",
    product_id: product_id
  }).then(res => {
    return {
      ...res,
      data: {
        contract: res.data,
      }
    };
  }),



  addCountry: (product_id, country_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_country",
    product_id: product_id,
    country_id: country_id

  }),

  addTerritory: (product_id, territory_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_territory",
    product_id: product_id,
    territory_id: territory_id
  }),

  productDetailsTabMetadata: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_details_tab_metadata",
    product_id: product_id,
    output: JSON_STRING
  }),

  showMetadata: (external_id) => MHTTPCL.post(LABEL_URL, {
    action: "show_metadata",
    external_table: "product",
    external_id: external_id,
    output: JSON_STRING
  }),

  standardMechanical: (product_id, mechanical_rate_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "standard_mechanical",
    product_id: product_id,
    mechanical_rate_id: mechanical_rate_id,
    output: JSON_STRING
  }),

  // blob:https://dev.berlin3.com/de8b42fb-67a1-4b2a-be97-2328eb392e2b
  exportTAccounts: (product_id, account_id) => MHTTPCL.postJSONasFormData(LABEL_URL, {
    section: "products",
    action: "export_t_accounts",
    product_id: product_id,
    account_id: account_id
  }, createHttpGetOptions({ responseType: 'blob' })),


  saveExcessMechanicalRate: (product_id, excess_mechanical_rate) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "save_excess_mechanical_rate",
    product_id: product_id,
    excess_mechanical_rate: excess_mechanical_rate
  }),

  deleteOrderline: (orderline_id, product_id) => MHTTPCL.post(LABEL_URL, {
    action: "delete_orderline",
    product_id: product_id,
    orderline_id: orderline_id,
    section: "products"
  }),

  stockAdjustmentModal: (product_id, account_id, stock_qty) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "stock_adjustment_modal",
    product_id: product_id,
    account_id: account_id,
    stock_qty: stock_qty

  }),

  adjustStock: (product_id, stock_qty, account_id, adjusted_stock, notes, date) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "adjust_stock",
    product_id: product_id,
    stock_qty: stock_qty,
    account_id: account_id,
    adjusted_stock: adjusted_stock,
    notes: notes,
    date: date
  }),

  unrelatedTracks: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "unrelated_tracks",
    product_id: product_id
  }),

  addSelectedTracks: (product_id, track_list) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "add_selected_tracks",
    product_id: product_id,
    track_list: track_list,
    output: JSON_STRING
  }),

  productNewTrack: (product_id, title, artist, playtime, isrc, version, digital_right_type) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_new_track",
    product_id: product_id,
    title: title,
    version: version,
    artist: artist,
    playtime: playtime,
    isrc: isrc,
    digital_right_type: digital_right_type,
    output: JSON_STRING
  }),

  duplicateTrack: (track_id, product_id, artist, title, version, playtime) => MHTTPCL.post(LABEL_URL, {
    section: "tracks",
    action: "duplicate_track",
    track_id: track_id,
    product_id: product_id,
    artist: artist,
    title: title,
    version: version,
    playtime: playtime
  }),

  searchProductCatalogs: (product_id,search) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "search_product_catalogs",
    product_id: product_id,
    search:search
  }),
  productCatalogs: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_catalogs",
    product_id: product_id
  }),
  copyTrackFromCatalog: (main_product_id, product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "copy_track_from_catalog",
    main_product_id: main_product_id,
    product_id: product_id,
    output: JSON_STRING

  }),

  //"update_all_playtime"

  updatePlayTime: (action, product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: action,
    product_id: product_id
  }),

  productTracksHtml: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_tracks_html",
    product_id: product_id,
    output: JSON_STRING
  }),

  costTab: (external_id) => MHTTPCL.post(LABEL_URL, {
    section: "releases",
    action: "cost_tab",
    external_table: 'product',
    external_id: external_id
  }),
  costReleaseTab: (external_id) => MHTTPCL.post(LABEL_URL, {
    section: "releases",
    action: "cost_tab",
    external_table: 'release_income',
    external_id: external_id
  }),
 // https://dev.berlin3.com/designcheck/label.pl?section=releases&action=cost_tab&external_table=release_income&external_id=116
  otherIncomeTab: (external_id) => MHTTPCL.post(LABEL_URL, {
    section: "releases",
    action: "cost_tab",
    external_table: 'product_income',
    external_id: external_id
  }).then(res => {
    return {
      ...res,
      data: {
        other_incomes: res.data.costs,
        product_other_incomes_total: res.data.product_costs_total,
      }
    };
  }),

  costGeneralData: () => MHTTPCL.post(LABEL_URL, {
    section: "common",
    action: "cost_general_data"
  }),

  modifyGema: (kVal, set_no, media_id, mechanical_reg_no) => MHTTPCL.post(MODIFICATION_URL, {
    modify_type: "record",
    table: "l_product_media",
    kVal: kVal,
    set_no: set_no,
    media_id: media_id,
    mechanical_reg_no: mechanical_reg_no
  }),

  getLabelcopy: (product_id) => MHTTPCL.post(LABEL_URL, {
    action: "get_labelcopy",
    product_id: product_id,
    section: "products"
  }),
  stockReallocationModalData: (product_id) => MHTTPCL.post(LABEL_URL, {
    action: "stock_reallocation_modal_data",
    product_id: product_id,
    row_start:0,
    section: "products"
  }),
  reallocateStock: ({product_id,
    account_id,
    contra_account_id,
    notes,
    date,
    qty}) => MHTTPCL.post(LABEL_URL, {
    action: "reallocate_stock",
    product_id,
    account_id,
    contra_account_id,
    notes,
    qty,
    date,
    section: "products"
  }),
  viewLabelProductOverviewPrintSlectTemplate: (product_id) => MHTTPCL.get(LABEL_URL, {
    section: "products",
    action: "view_label_product_overview_print_slect_template",
    section_name: "label",
    product_id: product_id

  }),

  getAccounts: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "get_accounts",
    product_id: product_id
  }),

  productRelationInfo: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "product_relation_info",
    product_id: product_id
  }),
  getProductRelatedSupplierOrderlines: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "get_product_related_supplier_orderlines",
    product_id: product_id
  }),

  removeProduct: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "remove_product",
    product_id: product_id
  }),

  updateReleaseContracts: (product_id) => MHTTPCL.post(LABEL_URL, {
    section: "products",
    action: "update_release_contracts",
    product_id: product_id
  }),


  //::::::::::::::::::::::::::

  updateProductAltArtistTitle:({alt_artist,alt_title,release_shift,product_id,preorder_date})=>MHTTPCL.post(JSONAPI_URL,{
    action	:"update_product_alt_artist_title",
    alt_artist	:alt_artist,
    alt_title	:alt_title,
    release_shift	:release_shift,
    product_id	:product_id,
    preorder_date	:preorder_date,
    output:JSON_STRING
  }),

  productStockLocationInfo:(product_id)=>MHTTPCL.post(LABEL_URL,{
    section	:"products",
    action	:"product_stock_location_info",
    product_id:	product_id,
    output:JSON_STRING
  }),

  searchUnrelatedTracks:(product_id,search)=>MHTTPCL.post(LABEL_URL,{
    section	:"products",
    action	:"search_unrelated_tracks",
    product_id	:product_id,
    search	:search
  }),
  modify: ({ kVal, name, value }) =>
  MHTTPCL.post('/modify.pl', {
      kVal,
      name,
      value,
      table: 'l_products',
      output: "json",

  }),

  




























}


//MHTTPCL.postFormData();